import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTFUWidgetSubject, TTFUWidget, fetchTfuWidget } from '../../../store/TFU';
import { getSelectedTab, updateState } from '../../../store/GeneralStore';

const TFUWidgetLabels = {
  myOverdueCount: { label: 'My Overdue Follow-Ups', tabIndex: 0 },
  myPendingCount: { label: 'My Pending Follow-Ups', tabIndex: 1 },
  pendingCount: { label: 'Pending Follow-Ups', tabIndex: 3 }
};

export const TFUWidget = () => {
  const [tFUWidgetData, setTFUWidgetData] = useState<TTFUWidget | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const widgetSub = getTFUWidgetSubject().subscribe((a) => setTFUWidgetData(a));

    fetchTfuWidget();

    return () => {
      if (widgetSub) widgetSub.unsubscribe();
    };
  }, []);

  if (!tFUWidgetData) return <></>;

  function handleClick(index: number) {
    updateState({
      selectedTab: {
        ...getSelectedTab(),
        tfus: index
      }
    });
    navigate('/ticket-follow-ups');
  }

  return (
    <dl className="grid grid-cols-1 sm:grid-cols-3 border rounded-xl border-gray-200 divide-y sm:divide-y-0 sm:divide-x divide-gray-200 overflow-hidden my-4">
      {Object.keys(TFUWidgetLabels).map((key) => (
        <button
          key={key}
          onClick={() => handleClick(TFUWidgetLabels[key as keyof typeof TFUWidgetLabels].tabIndex)}
          className="p-3 text-center hover:bg-gray-50 transition-colors focus:outline-none w-full">
          <dd className="text-sm font-normal text-gray-900 leading-6">
            {TFUWidgetLabels[key as keyof typeof TFUWidgetLabels].label}
          </dd>
          <dt className="text-[22px] font-normal leading-6">{tFUWidgetData[key as keyof typeof tFUWidgetData]}</dt>
        </button>
      ))}
    </dl>
  );
};
